import {
  DesignationsUnderCycleProps,
  GetCycleList,
  DesignationsUnderCycleResponse,
  DesignationWiseKRAsProps,
  SearchKRAList,
  KpiForIndividualKra,
  GetDesignationsUnderCycle,
  KraLookups,
  CheckedUnderKra,
  UnderKraID,
} from '../../../../types/Performance/AppraisalTemplate/appraisalTemplateTypes'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../../utils/apiUtils'
import { AppraisalTemplateApiConfig, AllowedHttpMethods } from '../../apiList'

const activeCycle = async (): Promise<GetDesignationsUnderCycle> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: AppraisalTemplateApiConfig.activeCycle,
    method: AllowedHttpMethods.get,
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const cycle = async (): Promise<GetCycleList[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: AppraisalTemplateApiConfig.cycle,
    method: AllowedHttpMethods.get,
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const getDesignationsUnderCycle = async (
  props: DesignationsUnderCycleProps,
): Promise<DesignationsUnderCycleResponse> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: AppraisalTemplateApiConfig.getDesignationsUnderCycle,
    method: AllowedHttpMethods.get,
    params: {
      cycleId: props.cycleId,
      endIndex: props.endIndex,
      startIndex: props.startIndex,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const getDesignationWiseKRAs = async (
  props: DesignationWiseKRAsProps,
): Promise<KraLookups[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: AppraisalTemplateApiConfig.getDesignationWiseKRAs,
    method: AllowedHttpMethods.get,
    params: {
      departmentId: props.departmentId,
      designationId: props.designationId,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const searchKRAList = async ({
  departmentId,
  designationId,
  endIndex,
  multipleSearch,
  startIndex,
}: {
  departmentId: number
  designationId: number
  endIndex: number
  multipleSearch: string
  startIndex: number
}): Promise<SearchKRAList> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: AppraisalTemplateApiConfig.searchKRAData,
    method: AllowedHttpMethods.post,
    data: {
      departmentId,
      designationId,
      endIndex,
      multipleSearch,
      startIndex,
    },
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const kpisForIndividualKra = async ({
  kraId,
}: {
  kraId: number
}): Promise<KpiForIndividualKra[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: AppraisalTemplateApiConfig.kpisForIndividualKra,
    method: AllowedHttpMethods.get,
    params: {
      kraId,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const designingmaping = async (
  data: GetDesignationsUnderCycle,
): Promise<GetDesignationsUnderCycle> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: AppraisalTemplateApiConfig.designingmaping,
    method: AllowedHttpMethods.post,
    data,
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const checkedUnderKras = async (
  body: UnderKraID,
): Promise<CheckedUnderKra[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: `${AppraisalTemplateApiConfig.checkedUnderKras}/${body.cycleId}/${body.designationId}`,
    method: AllowedHttpMethods.get,
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const AppraisalTemplateApi = {
  activeCycle,
  cycle,
  getDesignationsUnderCycle,
  getDesignationWiseKRAs,
  searchKRAList,
  kpisForIndividualKra,
  designingmaping,
  checkedUnderKras,
}

export default AppraisalTemplateApi
